<template>
  <div class="content content--sub">
    <OverlayLoader v-if="!$store.getters.engagementProjectsLoaded && currentSelectedTab.idEngagement"></OverlayLoader>
<!--    <div class="bg-img">-->
<!--&lt;!&ndash;      <img src="../../assets/images/hero-performance.jpg">&ndash;&gt;-->
<!--    </div>-->

    <MyHeader :breadcrumbItems="[

        {
          name: section.name,
          path: `/${$route.params.companySlug}/what-we-do-for-you`
        },
      ]"/>

    <header class="content-header">
      <h1>{{section.name}}</h1>
      <button :class="['article-list-button', {active: showList}]" @click="showList = ! showList"><i class="icon-list"></i></button>
    </header>

    <transition name="fade">
      <div class="article-list" v-if="showList">
        <TabMenuList :tabs="tabs" @closeMenu="showList=false"></TabMenuList>
      </div>
    </transition>

    <div class="container main-content--tabbed">
      <div class="row">
        <div class="col-lg-3 d-none d-lg-block">
          <TabMenuList :tabs="tabs" @closeMenu="showList=false"></TabMenuList>
        </div>
        <div class="col-lg-9 article-content">
          <template v-for="item in content">
            <HtmlContent v-if="item.sections" :content="{
              contenthtml: item.valueDescription,
              class: item.class,
              sections: item.sections.map(elem => {
                return {
                  value: elem.value,
                  caption: elem.valueDescription,
                  idSettingCompany: elem.idSettingCompany
                }
              },
              )
            }" :key="item.idSettingCompany"></HtmlContent>
            <div class="row" v-else-if="item.type === 'projects'" :key="item.idSettingCompany">
              <div class="col-lg-4" v-for="box in item.boxes" :key="box.idEngagementProject">
                <EngagementProjectBox :box="box"></EngagementProjectBox>
              </div>
            </div>
            <VideoWrapper v-else-if="item.type === 'video'"  :video-link="item.videoURL" :key="item.idSettingCompany"></VideoWrapper>
            <HtmlContent v-else :content="{contenthtml: item.value}" :key="item.idSettingCompany"></HtmlContent>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/general/Header'
import tabsMixin from "@/mixins/tabsMixin";
import {slugify} from "@/helpers/slugify";
import TabMenuList from "@/components/tabs/TabMenuList";
import settings from "@/settings";
import HtmlContent from "@/components/general/HtmlContent";
import OverlayLoader from "@/components/general/OverlayLoader";
import EngagementProjectBox from "@/components/engagements/EngagementProjectBox";
import VideoWrapper from "@/components/general/VideoWrapper";

export default {
  name: "WhatWeDoForYou",
  components: {VideoWrapper, EngagementProjectBox, OverlayLoader, HtmlContent, TabMenuList, MyHeader },
  mixins: [tabsMixin],
  data () {
    return {
      showList: false,
      activeTab: 1,
    }
  },
  mounted() {
    this.$store.dispatch("getEngagements")
    window._paq.push(['setDocumentTitle', this.section.name]);
    window._paq.push(['trackPageView']);
  },
  watch: {
    'currentSelectedTab': {
      deep: true,
      handler(val) {
        if(val.idEngagement) {
          // this.getKeyFacts();
          this.getProjects();
        }
      }
    }
  },
  computed: {
    engagements() {
      return this.$store.getters.engagements.filter(item => !item.hideOutOfTeamSection).map(item => {
        return {
            ...item,
            ...{id: item.idEngagement}}
          })
    },
    tabContent() {
      let tabs = []
      if(!this.$store.getters.settingsCompanyFlagByCode(settings.SETTING_TYPES_FLAGS.HIDE_OVERVIEW_TAB)) {
        tabs.push({
          name: 'Overview',
          slug: 'overview',
          type: 'overview'
        })
      }
      return [...tabs, ...this.engagements]
    },
    content() {
      if (this.currentSelectedTab.name === 'Overview') {
        let content = this.$store.getters.settingsCompanyByCode(settings.SETTING_TYPES.OVERVIEW);
        if(this.$store.getters.settingsCompanyBySettingTypeCode(settings.SETTING_TYPES.KEY_FACTS).length) {
          content.push({
            class: 'key-facts',
            valueDescription: '<h2>Key Facts</h2>',
            sections: this.$store.getters.settingsCompanyBySettingTypeCode(settings.SETTING_TYPES.KEY_FACTS)
          })
        }
        if(this.$store.getters.settingsCompanyBySettingTypeCode(settings.SETTING_TYPES.MAP_DATA).length) {
          let mapTitle = this.$store.getters.settingsCompanyByCode(settings.SETTING_TYPES.USE_CUSTOM_OVERVIEW_MAP_TITLE)
          content.push({
            class: 'map-data',
            valueDescription: mapTitle && mapTitle.length ? `<h2>${mapTitle[0].value}</h2>` : '<h2>Our global presence</h2>',
            sections: this.$store.getters.settingsCompanyBySettingTypeCode(settings.SETTING_TYPES.MAP_DATA)
          })
        }
        if(this.$store.getters.settingsCompanyBySettingTypeCode(settings.SETTING_TYPES.TIMELINE_DATA).length) {
          content.push({
            class: 'key-highlights',
            valueDescription: '<h2>Key Highlights</h2>',
            sections: this.$store.getters.settingsCompanyBySettingTypeCode(settings.SETTING_TYPES.TIMELINE_DATA)
          })
        }

        return content
      }
      let content =  [{
        value: `<h3>${this.currentSelectedTab.headline}</h3>${this.currentSelectedTab.lead}`,
        idSettingCompany: 1
      }]
      if(this.$store.getters.engagementProjects && this.$store.getters.engagementProjects.length) {
        content.push({
          type: 'projects',
          boxes: this.$store.getters.engagementProjects
        })
      }
      if(this.currentSelectedTab.videoURL) {
        content.push({
          type: 'video',
          videoURL: this.currentSelectedTab.videoURL
        })
      }
      return content
    },
    tabs() {
      return this.tabContent.map(item => {
        return {
          name: item.name,
          slug: item.idEngagement ? item.idEngagement : slugify(item.name),
          type: item.type
        }
      })
    },
    section() {
      return this.$store.getters.menu().find((item) => {
        return item.routeName === 'WhatWeDoForYou'
      })
    }
  },
  methods: {
    getProjects() {
      this.$store.dispatch('getEngagementProject', {idEngagement: this.currentSelectedTab.idEngagement, _embed: 1})
    },
    getKeyFacts() {
      this.$store.dispatch('getEngagementKeyFacts', {idEngagement: this.currentSelectedTab.idEngagement, _embed: 1})
    }
  }
}
</script>
